<template>
  <div>
    <div class="ProseMirrorHeader">Kommentar</div>
    <editor-content :editor="editor" />
  </div>
</template>

<script>
import tippy from "tippy.js";
import { Editor, EditorContent, VueRenderer } from "@tiptap/vue-2";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Mention from "@tiptap/extension-mention";
import MentionList from "@/components/shared/comments/MentionList.vue";

var CustomMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent(),
      "data-user": {
        default: "",
      },
    };
  },
});

export default {
  components: {
    EditorContent,
  },
  props: {
    value: {
      required: true,
    },
    tagUsers: {
      default: [],
    },
    closeDialog: {
      required: true,
    },
  },
  data() {
    return {
      editor: null,
      limit: 280,
    };
  },
  methods: {
    internalTags() {
      return this.tagUsers;
    },
  },
  watch: {
    value(selectedTemplet) {
      if (selectedTemplet) {
        this.editor.commands.setContent(selectedTemplet.template);
      }
    },
    closeDialog(value) {
      if (value) {
        //When close dialog. Delete content/text
        this.editor.commands.clearContent(true);
      }
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [
        Document,
        Paragraph,
        Text,
        CustomMention.configure({
          HTMLAttributes: {
            class: "mention",
          },
          suggestion: {
            items: this.internalTags,
            render: () => {
              let component;
              let popup;

              return {
                onStart: (props) => {
                  component = new VueRenderer(MentionList, {
                    parent: this,
                    propsData: props,
                  });
                  popup = tippy("body", {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: "manual",
                    placement: "bottom-start",
                  });
                },
                //when @ + letter
                onUpdate(props) {
                  props.items = props.items.filter((item) =>
                    item.value
                      .toLowerCase()
                      .startsWith(props.query.toLowerCase())
                  );
                  component.updateProps(props);
                  popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                  });
                },
                onKeyDown(props) {
                  if (props.event.key === "Escape") {
                    popup[0].hide();

                    return true;
                  }

                  return component.ref.onKeyDown(props);
                },
                onExit() {
                  popup[0].destroy();
                  component.destroy();
                },
              };
            },
          },
        }),
      ],
      content: this.comment,
    });

    this.editor.on("update", ({ editor }) => {
      var data = {
        comment: "",
        tags: [],
      };
      //Get comment and tags if content is not empty
      if (!editor.isEmpty) {
        data.comment = editor.getHTML();
        var doc = new DOMParser().parseFromString(data.comment, "text/html");
        var users = doc.getElementsByTagName("span");
        data.tags = [...users].map((x) => {
          return x.dataset.user;
        });
      }

      this.$emit("updateComment", data);
    });
  },
  beforeUnmount() {
    this.content;
    this.editor.destroy();
  },
};
</script>

<style lang="scss">
.ProseMirror:focus {
  outline: none;
  border-bottom: 2px solid var(--v-primary-base);
}
/* Basic editor styles */
.ProseMirror {
  padding: 10px 12px;
  background-color: var(--v-input-base);
  border-bottom: 1px solid var(--v-grey-base);
  //   color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  > * + * {
    // margin-top: 0.75em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }
  p {
    margin-bottom: 2px;
    color: var(--v-inputText-base);
  }
}
.ProseMirrorHeader {
  padding: 12px 12px 0px;
  background-color: var(--v-input-base);
  font-size: 12px;
}

.mention {
  color: var(--v-primary-base);
  background-color: var(--v-input-base);
  border-radius: 0.3rem;
  padding: 0.1rem 0.3rem;
}
.tippy-box {
  max-width: 550px !important;
}
.items li button {
  padding: 0.3rem 0rem 0.5rem 0.5rem;
  font-size: 0.96rem;
}
</style>
